module.exports = __webpack_public_path__ + "static/img/banner-bg1.b7f628e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/banner-bg1.jpg
// module id = grqf
// module chunks = 49